(function () {
	'use strict';

	angular.module('dcApp').directive('metadataInfo', [
		'$parse',
		function ($parse) {
			var controller = [
				'$scope',
				'$rootScope',
				'$timeout',
				'$q',
				'MetadataService',
				'UserService',
				function (
					$scope,
					$rootScope,
					$timeout,
					$q,
					MetadataService,
					UserService
				) {
					$scope.currentDate = moment(new Date()).format('LLLL');

					var vm = this;

					vm.init = function () {
						$scope.htmlId =
							vm.config && vm.config.htmlId ? vm.config.htmlId : '';
						if (!vm.isNew) {
							// edit or duplicate
							vm.hide_advanced = true;
						}
					};

					$scope.getDateTimeWithPattern = function (date) {
						return $rootScope.getDateTimeWithPattern(date);
					};

					$scope.copyInfo = function (value) {
						copyToClipboard(value);
						$scope.isCopied = true;
						$timeout(function () {
							$scope.isCopied = false;
						}, 600);
					};

					// The popover is a dxPopover, and building one forces a style
					// recalculation of the whole page: with a card per project, that
					// is the bulk of the page's load. Nobody opens most of them, so it is
					// built on the first click on the icon and kept from then on.
					// The widget sits under an ng-if, so its visibility is a property
					// of this object: a plain scope variable would be shadowed by the
					// child scope the first time the popover closes itself.
					$scope.metadataState = { built: false, visible: false };

					$scope.showPopover = function ($event) {
						// The icon that was clicked, not an id selector: a project that
						// carries several tags is rendered under each of them, so its icon
						// id exists once per copy and the selector would find the first one
						// on the page, wherever that copy is. Read now: the event is gone
						// when the data arrives.
						var icon = $event && $event.currentTarget;
						$scope.metadataPopover = {
							id: vm.data.id,
							code: vm.data.code,
							updateDate: vm.data.updateDate,
							creationDate: vm.data.creationDate,
							createdBy: vm.data.createdBy,
							updatedBy: vm.data.updatedBy,
						};
						if (
							vm.data.metadataId !== undefined &&
							vm.data.metadataId !== '' &&
							!isNaN(vm.data.metadataId)
						) {
							// The popover is opened once everything it shows is known. It is
							// placed, and the side of its arrow chosen, when it opens: with
							// content still to come its height changes afterwards, and near
							// the top of the page, where there is barely room above the
							// icon, the arrow ended up on the wrong side.
							MetadataService.getMetadataTrace(vm.data.metadataId)
								.then(function (response) {
									let data = response.data;
									$scope.metadataPopover.createdBy = data.created_by;
									$scope.metadataPopover.creationDate = data.creation_date;
									$scope.metadataPopover.updateDate = data.update_date;
									$scope.metadataPopover.updatedBy = data.updated_by;
									var names = [];
									if ($scope.metadataPopover.createdBy) {
										names.push(
											UserService.getUserById(
												$scope.metadataPopover.createdBy
											).then(function (res1) {
												$scope.metadataPopover.createdBy = res1.data.name;
											})
										);
									}
									if ($scope.metadataPopover.updatedBy) {
										names.push(
											UserService.getUserById(
												$scope.metadataPopover.updatedBy
											).then(function (res1) {
												$scope.metadataPopover.updatedBy = res1.data.name;
											})
										);
									}
									return $q.all(names);
								})
								// A failed request still opens it, with what the card knows.
								.catch(angular.noop)
								.then(function () {
									openPopover(icon);
								});
						}
						// Set a bigger z-index
						$(function () {
							DevExpress.ui.dxOverlay.baseZIndex(1999999998);
						});
						$event.stopPropagation();
					};

					function openPopover(icon) {
						initPopover(icon);
						// Set before the flag the widget binds its visibility to, so
						// the popover this digest creates already reads as open.
						$scope.metadataState.built = true;
						$scope.metadataState.visible = true;
					}

					function initPopover(icon) {
						$scope.metadataDetailsPopover = {
							target: icon || '#metadataInfoPopover' + vm.data.metadataId,
							showEvent: 'dxclick',
							position: 'top',
							width: 450,
							bindingOptions: {
								visible: 'metadataState.visible',
							},
						};
					}
				},
			];

			return {
				restrict: 'E',

				scope: {
					data: '=',
					isNew: '=',
					config: '=',
				},
				controller: controller,
				controllerAs: 'vm',
				bindToController: true,
				templateUrl:
					'./src/components/directives/metadataInfo/metadataInfo.html',
				transclude: true,
				replace: true,
				link: function postLink(scope, element, attrs) {
					scope.vm.init(attrs);
					scope.metadataPopover = {};
				},
			};
		},
	]);
})();
